// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import EventRegistrationRequestSchema from './event-registration-request-schema';

const schema = {
  $id: '/update-event-checkout-request-schema',
  type: 'object',
  required: ['eventId', 'id'],
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    checkoutRequest: {
      ...EventRegistrationRequestSchema,
    },
    eventId: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
